import React from 'react';
import { Activity } from '../../types/activity';
import { ActivityCard } from './ActivityCard';

interface ActivityTimelineProps {
  activities: Activity[];
  currentUserId?: string;
  onEdit?: (activity: Activity) => void;
  onDelete?: (activity: Activity) => void;
}

const formatDateGroup = (dateString: string): string => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return 'Today';
  }
  if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  }
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

const groupByDate = (activities: Activity[]): Map<string, Activity[]> => {
  const groups = new Map<string, Activity[]>();

  activities.forEach((activity) => {
    const dateKey = new Date(activity.createdAt).toDateString();
    const existing = groups.get(dateKey) || [];
    groups.set(dateKey, [...existing, activity]);
  });

  return groups;
};

export const ActivityTimeline: React.FC<ActivityTimelineProps> = ({
  activities,
  currentUserId,
  onEdit,
  onDelete,
}) => {
  const groupedActivities = groupByDate(activities);

  return (
    <div className="space-y-6">
      {Array.from(groupedActivities.entries()).map(([dateKey, dateActivities]) => (
        <div key={dateKey}>
          <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">
            {formatDateGroup(dateActivities[0].createdAt)}
          </h3>
          <div className="space-y-3">
            {dateActivities.map((activity) => (
              <ActivityCard
                key={activity.id}
                activity={activity}
                currentUserId={currentUserId}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
